import { render, staticRenderFns } from "./TrapDetail.vue?vue&type=template&id=67aa8ea8&"
import script from "./TrapDetail.vue?vue&type=script&lang=js&"
export * from "./TrapDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/web apps/HMS_Web_App_Vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VDivider,VFlex,VLayout,VList,VListTile,VListTileContent,VProgressLinear})
